// ======================================================================
// File Name       : UserHistoryStudentList
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import PropTypes from 'prop-types';
import { Table, Button, Col } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import TableHead from '../../../components/TableHead';
import {
  convertObjectToList,
  convertUserIdToUserName,
  convertGroupListIdToGroupName,
} from '../../../utils/UserUtils';
import ReduxFormPaging from '../../../components/ReduxFormPaging';
import store from '../../../store';
import CustomLink from '../../button/CustomLink';
import * as Path from '../../../constants/PathConstants';
import * as ICON from '../../../constants/IconConstants';

class UserHistoryStudentList extends React.Component {
  render() {
    const {
      groupRelationList,
      userList, groupList,
      courseStatusList,
      goToDetail,
      handleSortState,
      user,
      eachUserCourseStatusCount,
      recordNum,
      getStartEndData,
      handleMouseEnter,
      handleMouseLeave,
      hoverIndex,
    } = this.props;
    const groupListByUser = convertObjectToList(groupRelationList, 'userSecernId', 'groupSecernId');
    const thead = [
      { title: 'ユーザー名', sortBy: 0 },
      { title: 'ユーザーグループ名', sortBy: null },
      { title: '所属コース数', sortBy: null, width:'10%' },
      { title: 'コース完了数', sortBy: null, width:'10%'},
      { title: '操作', sortBy: null, width: 130 },
    ];
    let groupListAll = groupList;
    if (user && user.allGroup && user.allGroup.length) {
      groupListAll = user.allGroup;
    }
    const dataTable =
      userList && userList.length !== 0
        ? userList.map((userItem, index) => {
          const { userSecernId, dormantState } = userItem;
          const userName = convertUserIdToUserName(userSecernId, userList);
          let groupSecernIdList = [];
          if (groupListByUser && Object.keys(groupListByUser).length) {
            groupSecernIdList = groupListByUser[userSecernId] &&
            groupListByUser[userSecernId].groupSecernId ?
            groupListByUser[userSecernId].groupSecernId : [];
          }
          const courseObject = eachUserCourseStatusCount &&
          eachUserCourseStatusCount[userSecernId] ?
          eachUserCourseStatusCount[userSecernId] : null;
          // START #6052
          const attendingCourseCount = courseObject && courseObject.attendingCourseCount ? courseObject.attendingCourseCount : 0;
          const endConditionAchievementCourseCount = courseObject && courseObject.endConditionAchievementCourseCount ?
          courseObject.endConditionAchievementCourseCount : 0;
          // END #6052
          const groupName = convertGroupListIdToGroupName(groupSecernIdList, groupListAll);
          let classNameInActiveUser = null;
          if (dormantState === 1) {
            classNameInActiveUser = 'inactive-class';
          }
          const link = Path.USER_HISTORY_STUDENT_DETAIL.replace(':id', userSecernId);
          return (
            <tr key={index} className={classNameInActiveUser} onMouseEnter={() => handleMouseEnter(index)} onMouseLeave={() => handleMouseLeave()}>
              <td>{userName}</td>
              <td>{groupName}</td>
              <td className="text-right">{attendingCourseCount}</td>
              <td className="text-right">{endConditionAchievementCourseCount}</td>
              <td className="text-center">
                {/* START #6052 */}
                {parseInt(attendingCourseCount, 10) > 0 && (
                  <CustomLink
                    className="margin-right-7 link-detail"
                    to={link}
                    text="詳細を見る"
                  />
                )}
                {/* END #6052 */}
              </td>
            </tr>
          );
        })
        : null;
    return (
      <div>
        <Table striped hover>
          <thead>
            <ReduxFormPaging
              type="tableHead"
              data={thead}
              name="userSortType"
              handleSortState={handleSortState}
            />
          </thead>
          <tbody>
            {dataTable}
          </tbody>
        </Table>
        <Col sm={12} className="d-flex justify-content-center">
          <ReduxFormPaging
            type="paging"
            name="startPosition"
            recordNum={recordNum}
            getStartEndData={getStartEndData}
          />
        </Col>
      </div>
    );
  }
}

export default UserHistoryStudentList;
